import cookie from './cookies';

const $ = window.jQuery;

const s = {
  alertBar : $('.alert-bar'),
  cookieName : 'STYXKEY_alert-bar'
}

function init() {

  /** Show Alert Bar */
  if (cookie(s.cookieName) === undefined || cookie(s.cookieName) !== 'inactive') {
    cookie(s.cookieName, 'active');
    s.alertBar.addClass('active').removeClass('inactive');
  }
  else if (cookie(s.cookieName) === 'inactive') {
    s.alertBar.addClass('inactive').removeClass('active');
  }

  /** Add Dismissible Class */
  s.alertBar.addClass('alert-bar--dismissible');

  /** Add Dismiss Button */
  s.alertBar.append('<button class="alert-bar__dismiss">Dismiss</button>');

  events();
}

function events() {

  /** Hide Alert Bar */
  $('.alert-bar__dismiss').on('click', function(event) {
    event.preventDefault();
    cookie(s.cookieName, 'inactive', { 'maxage' : 1 }); // Expires in 1 Day
    s.alertBar.addClass('inactive ').removeClass('active');
  });
}

export {init as default}
